<template>
  <section>
    <left-menu :obChangeTheme="isDark"/>
    <view-communication :view-value="viewAlert" />
    <modal-nps-collaborator/>

    <div id="mainContent" class="home-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="box-user">
            <img v-if="userInfo.photo" v-bind:src="userInfo.photo" class="img-responsive user-photo" alt="Usuário"/>
            <div v-else class="user-name-photo"><span class="nunito">{{userInfo.name | formatName}}</span></div>

            <p class="nunito" v-bind:title="'Olá,' + userInfo.name"><span class="title-text">Olá, </span><strong>{{userInfo.name | limitTo(43)}}</strong></p>

            <div v-if="!loadings.main && !failRequestPoints" class="content-right">
              <div class="change-theme" v-bind:class="{'active-white': !isDark, 'active-dark': isDark}">
                <div v-on:click="changeTheme(false)">
                  <svg width="24" height="24" class="icon-color">
                    <path class="b" d="M5.565,3.95,4.138,2.531,3.021,3.649,4.439,5.067ZM3.377,8.435H1V10.02H3.377ZM10.51.55H8.925V2.888H10.51V.55Zm5.9,3.1L15.3,2.531,13.878,3.95,15,5.067ZM13.87,14.506l1.419,1.426,1.117-1.117L14.979,13.4,13.87,14.506Zm2.187-6.07V10.02h2.377V8.435ZM9.717,4.473a4.755,4.755,0,1,0,4.755,4.755A4.759,4.759,0,0,0,9.717,4.473ZM8.925,17.905H10.51V15.568H8.925Zm-5.9-3.1,1.117,1.117L5.557,14.5,4.439,13.38Z" transform="translate(-0.208 -0.114)"/>
                  </svg>
                </div>
                <div v-on:click="changeTheme(true)">
                  <svg width="24" height="24" class="icon-color">
                    <path class="b" d="M12.194,2a7.174,7.174,0,0,1,3.6.971,7.181,7.181,0,0,0,0,12.446A7.191,7.191,0,1,1,12.194,2Z" transform="translate(-1.403 -0.561)"/>
                  </svg>
                </div>

<!--                <aside v-if="showInfoNew" class="info-new">-->
<!--                  <h3 class="certa">Novidade!</h3>-->
<!--                  <p class="nunito">Agora você pode clicar aqui para ativar o <strong>Modo Escuro</strong>. Experimente!</p>-->
<!--                  <button v-on:click="hiddenNew()" class="nunito">Entendi</button>-->
<!--                </aside>-->
              </div>

              <a v-if="chatListPoints.showChat" v-on:click="openListChat()" class="cursor">
                <span v-if="chatListPoints.showNew && chatListPoints.count" class="notf-span2">{{chatListPoints.count}}</span>
                <svg class="force-svg" xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'>
                  <path d='M431,320.6c-1-3.6,1.2-8.6,3.3-12.2a33.68,33.68,0,0,1,2.1-3.1A162,162,0,0,0,464,215c.3-92.2-77.5-167-173.7-167C206.4,48,136.4,105.1,120,180.9a160.7,160.7,0,0,0-3.7,34.2c0,92.3,74.8,169.1,171,169.1,15.3,0,35.9-4.6,47.2-7.7s22.5-7.2,25.4-8.3a26.44,26.44,0,0,1,9.3-1.7,26,26,0,0,1,10.1,2L436,388.6a13.52,13.52,0,0,0,3.9,1,8,8,0,0,0,8-8,12.85,12.85,0,0,0-.5-2.7Z' style='fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px'/>
                  <path d='M66.46,232a146.23,146.23,0,0,0,6.39,152.67c2.31,3.49,3.61,6.19,3.21,8s-11.93,61.87-11.93,61.87a8,8,0,0,0,2.71,7.68A8.17,8.17,0,0,0,72,464a7.26,7.26,0,0,0,2.91-.6l56.21-22a15.7,15.7,0,0,1,12,.2c18.94,7.38,39.88,12,60.83,12A159.21,159.21,0,0,0,284,432.11' style='fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:32px'/>
                </svg>

                <aside v-if="chatListPoints.showList" class="chat-list">
                  <div class="list custom-scrollbar" v-bind:class="{'min-list': chatListPoints.list.length <= 4}">
                    <div v-if="chatListPoints.list.length" class="header">
                      <h3>Conversas</h3>
                      <a href="/conversas">Ver Todas</a>
                    </div>
                    <div v-if="chatListPoints.list.length" v-for="c in chatListPoints.list" class="chat-info">
                      <a v-bind:href="'/conversas/' + c.id">
                        <div class="user-photo-list">
                          <img v-if="c.photo" v-bind:src="c.photo" class="img-responsive img-circle" alt="user">
                          <img v-else src="../../../../assets/img/user-default.png" class="img-responsive" alt="user">
                        </div>

                        <div class="user-info" v-bind:class="{'is-unread': !c.isread}">
                          <p v-bind:title="c.userName" class="title">{{c.userName | limitTo(14)}} - <span>{{c.lastMessageDate | formatDayMonthHours}}</span></p>
                          <p v-bind:title="c.lastMessage" class="subject"><span v-if="c.whoSentLastMessage === userInfo.id">Você: </span>{{c.lastMessage | limitTo(18)}}</p>
                        </div>
                      </a>
                    </div>
                    <div v-if="!loadings.chat && !chatListPoints.list.length">
                      <p>Você ainda não possui nenhuma conversa, clique  <a href="/conversas" class="link">aqui</a> para iniciar uma nova conversa</p>
                    </div>
                    <div v-if="loadings.chat" class="loader-mini-box-notification">
                      <div class="spinner-box">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </div>

                </aside>
              </a>

              <a v-on:click="openList()" class="cursor">
                <span v-if="historyListPoints.showNew && historyListPoints.count" class="notf-span">{{historyListPoints.count}}</span>

                <svg width="44.401" height="50.177">
                  <g class="b" transform="matrix(1, 0, 0, 1, 0, 0)">
                    <path class="a" d="M17.2,34.677a3.31,3.31,0,0,0,3.3-3.3H13.9A3.3,3.3,0,0,0,17.2,34.677Zm9.9-9.9v-8.25C27.1,11.46,24.4,7.219,19.676,6.1V4.975a2.475,2.475,0,0,0-4.95,0V6.1C9.99,7.219,7.3,11.443,7.3,16.526v8.25L4,28.076v1.65H30.4v-1.65Z" transform="translate(5 3.5)"/>
                  </g>
                </svg>

                <aside v-if="historyListPoints.showList" class="history-point-list">
                  <div class="list custom-scrollbar" v-bind:class="{'min-list': historyListPoints.list.length <= 4}">
                    <div v-if="historyListPoints.list.length" v-for="lp in orderByDate(historyListPoints.list)">
                      <p>{{lp.text}}
                        <span v-if="lp.type === 1">{{lp.date | formatDateHoursSeconds}}</span>
                        <span v-if="lp.type === 2">{{lp.date | formatDate}}</span>
                      </p>
                    </div>
                    <div v-if="!loadings.notifications && !historyListPoints.list.length">
                      <p>Sem histórico de ponto até o momento.</p>
                    </div>
                    <div v-if="loadings.notifications" class="loader-mini-box-notification">
                      <div class="spinner-box">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </div>

                </aside>
              </a>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-point">
              <p class="title">
                <progress-loading v-if="loadings.main" :additionalBoxStyle="'min-height: 45px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 20px'"/>
                <span v-if="!loadings.main && dataPg.date" class="certa">{{dataPg.date | strDayFull}}, {{dataPg.date | formatDate}}</span>
              </p>

              <progress-loading v-if="loadings.main" :additionalBoxStyle="'min-height: 70px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 40px; margin-top: 14px'"/>
              <div v-if="!loadings.main" class="hour-time">
                <div class="hour"><span v-if="currentTime" class="certa">{{currentTime}}</span></div>
                <div class="info"><span class="nunito">Este é o horário oficial central e pode estar diferente do horário do seu computador.</span></div>
              </div>

              <div class="line-point-info">
                <div class="background-default" v-bind:class="{'background-bue-dark': dataPg.totalPoints}"></div>

                <progress-loading v-if="loadings.main" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; top: 10px; width: 76%'"/>
                <span v-if="!loadings.main && dataPg.totalPoints" class="text-point nunito">Último ponto registrado: {{showDateLastPoint}}</span>
                <span v-if="!loadings.main && !dataPg.totalPoints" class="text-point nunito">Último ponto registrado: {{showDateLastPoint}}</span>
              </div>

              <div v-if="showPointCache" class="content-process-point">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <circle cx="50" cy="50" r="32" stroke-width="8" stroke="#352da5" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.282051282051282s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
                  </circle>
                </svg>
                <h6 class="certa">Ponto em processamento</h6>
                <p>
                  Seu ponto das <strong>{{ dataLastPoint.lastDatePoint | formatHours }}</strong> já foi registrado! Ele está em processamento e ficará visível em alguns minutos.
                </p>
                <button class="certa" v-on:click="realodPage()">Clique aqui para atualizar a página</button>
              </div>

              <div v-if="!showPointCache" class="old-progress-bar">
                <div class="pending-hours">
                  <progress-loading v-if="loadings.main" :additionalBoxStyle="'margin-top: 70px'" :additionalLineStyle="'height: 16px; display: block; margin: 0 auto 20px;'"/>
                  <p v-if="!loadings.main" class="nunito"><span class="default-text">Horas faltantes</span></p>

                  <progress-loading v-if="loadings.main" :additionalBoxStyle="''" :additionalLineStyle="'height: 30px; display: block; margin: 30px auto 20px;'"/>
                  <p v-if="!loadings.main" v-bind:class="{'second-color': dataPg.userPointDayStatus === 2, 'one-color': dataPg.userPointDayStatus === 1}" class="certa">
                    {{dataWork.currentMissing}}
                    <span v-if="dataWork.currentMissing !== '00:00:00' && dataPg.userPointDayStatus === 1" class="nunito interval">você está em intervalo</span>
                  </p>
                </div>

                <progress-loading v-if="loadings.main" :additionalBoxStyle="''" :additionalLineStyle="'height: 18px; display: block; margin: 34px auto 20px;'"/>
                <div v-if="!loadings.main" class="progress-new-2">
                  <div class="line-progress">
                    <div v-bind:style="{'width': progressPercent <= 100 ? progressPercent + '%' : '100%'}"></div>
                  </div>

                  <div class="content-hours">
                    <span title="Total Trabalhado">
                      <progress-loading v-if="loadings.main"/>
                      <span v-else>{{dataWork.dayHours}}</span>
                    </span>
                    <span title="Total Necessário">
                      <progress-loading v-if="loadings.main"/>
                      <span v-else>{{dataPg.workingDayTotal}}</span>
                    </span>
                  </div>
                </div>
              </div>

              <progress-loading v-if="loadings.main && !showPointCache" :additionalBoxStyle="''" :additionalLineStyle="'height: 14px; display: block; margin: 34px auto 0px;'"/>
              <a v-if="!loadings.main && dataPg.id && !showPointCache" v-bind:href="'/detalhe-do-ponto/' + dataPg.id + '/5'" class="certa register-point">
                <span>
                  <i class="fa fa-eye" aria-hidden="true"></i>
                  Ver detalhes de hoje
                </span>
              </a>
            </div>
          </div>

          <!-- Alerta e Horas -->
          <div class="col-xs-12 col-sm-6 col-md-4" style="margin-bottom: 10px;">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-alert2">
              <i v-if="!loadings.ocAndAbs" v-on:click="forceBalance()" v-tooltip.top-center="'A última atualização dos dados foi feita no dia ' + this.datesAtt.balance + '. Para atualizar novamente, clique aqui.'" class="fa fa-info-circle info-help" aria-hidden="true"></i>
              <progress-loading v-if="loadings.ocAndAbs" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 5px auto 13px;'"/>
              <p v-if="!loadings.ocAndAbs && dataPg2.totalOccurrences <= 0" class="nunito title">
                Nenhuma ocorrência.
              </p>
              <div v-if="!loadings.ocAndAbs && dataPg2.totalOccurrences > 0">
                <i class="fa fa-exclamation-triangle icon-round icon-round2" aria-hidden="true"></i>
                <p class="nunito occurrences">{{dataPg2.totalOccurrences}} Ocorrências.</p>
                <a href="/historico-de-ocorrencia" class="certa resolver">Resolver</a>
              </div>
            </div>

            <div v-if="dataConfig.canSeeHoursBalance" class="col-xs-12 col-sm-12 col-md-12 default-box box-hour-balances offset-top-30">
              <progress-loading v-if="loadings.balance" :additionalBoxStyle="'min-height: 32px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px; display: block; margin: 5px auto 13px;'"/>
              <i v-if="!loadings.balance" v-on:click="forceBalance()" v-tooltip.top-center="'A última atualização dos dados foi feita no dia ' + this.datesAtt.balance + '. Para atualizar novamente, clique aqui.'" class="fa fa-info-circle info-help" aria-hidden="true"></i>
              <p v-if="!loadings.balance" class="certa title">Saldos de horas </p>

              <progress-loading v-if="loadings.balance" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 20px 0 10px;'"/>
              <progress-loading v-if="loadings.balance" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>

              <progress-loading v-if="loadings.balance" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 20px 0 10px;'"/>
              <progress-loading v-if="loadings.balance" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>

              <progress-loading v-if="loadings.balance" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 20px 0 10px;'"/>
              <progress-loading v-if="loadings.balance" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>

              <div v-if="!loadings.balance" v-for="s in balances" class="box-balance-info">
                <p>
                  <span class="nunito">{{s.month}}</span>
                  <span class="certa" v-bind:class="{'color-green': s.positive, 'color-red': !s.positive}">
                    <span v-if="s.positive && s.balance !== '00:00'" class="d-inline">+</span>
                    <span class="balance-hours" v-bind:class="{'balance-left': s.balance !== '00:00'}">{{s.balance}}</span>
                  </span>
                </p>
              </div>

              <progress-loading v-if="loadings.balance" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin-top: 20px;'"/>
              <div v-if="!loadings.balance && notices.length" class="show-more">
                <a href="/saldo-de-horas" class="certa">
                  <span>
                    <svg width="21.16" height="21.16" viewBox="0 0 21.16 21.16">
                      <path class="a" d="M17.894,2.765h-.883V1H15.245V2.765H6.415V1H4.649V2.765H3.766A1.77,1.77,0,0,0,2,4.529V18.645A1.77,1.77,0,0,0,3.766,20.41H17.894a1.77,1.77,0,0,0,1.766-1.765V4.529A1.77,1.77,0,0,0,17.894,2.765Zm0,15.881H3.766V7.176H17.894Z" transform="translate(-0.25 -0.125)"/>
                    </svg>
                    Selecionar período
                  </span>
                </a>
              </div>
            </div>

            <div v-if="$route.params.allTasks && $route.params.allTasks.hasPendingDocuments" class="col-xs-12 col-sm-12 col-md-12 default-box box-hour-balances box-requests-documents offset-top-30">
              <p class="certa title">
                <ion-icon name="alert-circle-sharp"/>Solicitações de documentos
              </p>
              <span class="text-content">
                <b> Você possui envio de documentos pendentes.</b>
              </span>
              <div class="body-button">
                <router-link :to="'/documentos?step=2'" class="button-send-documents">Enviar documentos</router-link>
              </div>
            </div>

            <div v-if="!dataConfig.canSeeHoursBalance" class="col-xs-12 col-sm-12 col-md-12 default-box box-last-solicitations offset-top-30">
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 32px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px; display: block; margin: 5px auto 13px;'"/>
<!--              <i v-if="!loadings.solicitations" v-on:click="forceSolicitation()" v-tooltip.top-center="'A última atualização dos dados foi feita no dia ' + this.datesAtt.solicitation + '. Para atualizar novamente, clique aqui.'" class="fa fa-info-circle info-help" aria-hidden="true"></i>-->
              <p v-if="!loadings.solicitations" class="certa title">Últimas solicitações</p>

              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>
              <progress-loading v-if="loadings.solicitations" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>


              <div v-if="!loadings.solicitations && dataSolicitation.listObject.length">
                <div v-for="s in dataSolicitation.listObject" class="box-solicitation">
                  <p class="nunito">Data: {{s.date}} <span class="solicitation" v-bind:class="{'green': s.status === 'Aprovado', 'blue': s.status === 'Solicitado', 'red': s.status === 'Reprovado'}">{{s.status}}</span></p>
                </div>
              </div>

              <div v-if="!loadings.solicitations && !dataSolicitation.listObject.length" class="empty-solicitation">
                <p class="nunito">Você ainda não possui nenhuma solicitação até o momento.</p>
                <img src="/src/assets/img/empty/solicitações.png" class="img-responsive" alt="sem solicitação"/>
              </div>
            </div>
          </div>

          <!-- Sentimentos ou Comunicados -->
          <div v-if="!failRequestPoints" class="col-xs-12 col-sm-12 col-md-4">
            <section v-if="showFeelingsDay" class="col-xs-12 col-md-12 col-sm-12 default-box box-feelings animate__animated animate__headShake animate__repeat-3">
              <div v-if="!sendFeelingsSuccess" class="col-xs-12 col-sm-12 col-md-12 content-text-info">
                <progress-loading v-if="loadings.feeling" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block;width: 70%;'"/>
                <h3 v-if="!loadings.feeling" class="certa">Como você está se sentindo?</h3>
              </div>
              <div v-if="!sendFeelingsSuccess" class="col-xs-12 col-sm-12 col-md-12 content-answer">
                <progress-loading v-if="loadings.feeling" :additionalBoxStyle="''" :additionalLineStyle="'height: 30px; display: block; margin: 0 auto;width: 70%;'"/>
                <div v-if="!loadings.feeling" class="set-feeling">
                  <img v-on:click="addFeeling(1)" v-bind:class="{'active': dataSendFeeling.mood === 1}" src="../../../../assets/img/feelings/1.png" class="img-fluid" alt="feeling"/>
                  <img v-on:click="addFeeling(2)" v-bind:class="{'active': dataSendFeeling.mood === 2}" src="../../../../assets/img/feelings/2.png" class="img-fluid" alt="feeling"/>
                  <img v-on:click="addFeeling(3)" v-bind:class="{'active': dataSendFeeling.mood === 3}" src="../../../../assets/img/feelings/3.png" class="img-fluid" alt="feeling"/>
                  <img v-on:click="addFeeling(4)" v-bind:class="{'active': dataSendFeeling.mood === 4}" src="../../../../assets/img/feelings/4.png" class="img-fluid" alt="feeling"/>
                  <img v-on:click="addFeeling(5)" v-bind:class="{'active': dataSendFeeling.mood === 5}" src="../../../../assets/img/feelings/5.png" class="img-fluid" alt="feeling"/>
                </div>
                <div class="client-send-op">
                  <progress-loading v-if="loadings.feeling" :additionalBoxStyle="''" :additionalLineStyle="'height: 50px; display: block;width: 100%;'"/>
                  <textarea v-if="!loadings.feeling" v-model="dataSendFeeling.comment" maxlength="200" placeholder="Nos conte por que está se sentindo assim"></textarea>

                  <progress-loading v-if="loadings.feeling" :additionalBoxStyle="''" :additionalLineStyle="'height: 14px; display: block;margin-top:5px;width: 100%;'"/>
<!--                  <p v-if="!loadings.feeling" class="obs default-text">Esta informação é privada e será vista apenas pelos administradores da sua empresa.</p>-->
                  <p v-if="!loadings.feeling" class="obs default-text">Fique tranquilo, essa informação só será visualizada por alguém que quer manter um sorriso no seu rosto, o seu gestor!</p>

                  <progress-loading v-if="loadings.feeling" :additionalBoxStyle="''" :additionalLineStyle="'height: 14px; display: block;margin-top:10px;width: 30%;'"/>
                  <button v-if="!loadings.feeling" v-on:click="sendFeelings()" type="submit" class="nunito">
                    <span v-if="!loadingSendFeeling">Enviar</span>
                    <div v-else class="loading-btn">
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5">
                        </div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              <div v-if="!loadings.feeling && sendFeelingsSuccess" class="col-xs-12 col-sm-12 col-md-12 content-success">
                <div class="success-checkmark">
                  <div class="check-icon">
                    <span class="icon-line line-tip"></span>
                    <span class="icon-line line-long"></span>
                    <div class="icon-circle"></div>
                    <div class="icon-fix"></div>
                  </div>
                </div>
                <p class="nunito">Sentimento enviado com sucesso!</p>
              </div>
            </section>

            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-announcements" v-bind:class="{'min-h-announcements': !showFeelingsDay}">
              <i v-if="!loadings.notice" v-on:click="forceNotice()" v-tooltip.top-center="'A última atualização dos dados foi feita no dia ' + this.datesAtt.notice + '. Para atualizar novamente, clique aqui.'" class="fa fa-info-circle info-help" aria-hidden="true"></i>
              <progress-loading v-if="loadings.notice" :additionalBoxStyle="'min-height: 32px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px; display: block; margin: 5px auto 13px;'"/>
              <p v-if="!loadings.notice" class="certa title">Comunicados <span v-if="notices.length" class="certa">{{noticesPending}} não lidos</span></p>

              <progress-loading v-if="loadings.notice" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 20px 0 10px;'"/>
              <progress-loading v-if="loadings.notice" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>

              <progress-loading v-if="loadings.notice && !showFeelingsDay" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 20px 0 10px;'"/>
              <progress-loading v-if="loadings.notice && !showFeelingsDay" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>

              <progress-loading v-if="loadings.notice && !showFeelingsDay" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 20px 0 10px;'"/>
              <progress-loading v-if="loadings.notice && !showFeelingsDay" :additionalBoxStyle="'min-height: 33px; border-bottom: 1px solid #F2F5F9;'" :additionalLineStyle="'height: 16px;'"/>

              <div v-if="!loadings.notice && notices.length"  class="limit-h custom-scrollbar" v-bind:class="{'limit-with-feelings': showFeelingsDay}">
                <router-link v-bind:to="'/detalhes-do-comunicado/' + n.id + '/1'"  v-for="n in notices.slice(0, 6)" class="box-alerts pointer">
                    <i v-bind:class="{'is-read i-read': n.isRead}" class="fa fa-circle" aria-hidden="true"></i>
                    <span v-if="n.type === 2 || n.companyStatementType === 2" class="block-urgent">Urgente</span>
                    <p class="nunito" v-bind:class="{'is-read': n.isRead, 'm-left': n.type === 2 || n.companyStatementType === 2}">{{n.title | limitTo(28)}}</p>
                    <p v-if="n.date" class="nunito" v-bind:class="{'is-read': n.isRead}">{{n.date}}</p>
                    <p v-if="n.createdAt && !n.date" class="nunito" v-bind:class="{'is-read': n.isRead}">{{n.createdAt | formatDateHours}}</p>
                </router-link>
              </div>

              <progress-loading v-if="loadings.notice" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin-top: 20px;'"/>
              <div v-if="!loadings.notice && notices.length" class="show-more">
                <a href="/comunicados" class="certa">
                  <span>
                    <svg width="14.107" height="17.192" viewBox="0 0 14.107 17.192">
                      <path class="a" d="M11.053,19.692a1.769,1.769,0,0,0,1.763-1.763H9.29A1.763,1.763,0,0,0,11.053,19.692Zm5.29-5.29V9.994c0-2.707-1.446-4.973-3.967-5.572v-.6a1.322,1.322,0,0,0-2.645,0v.6c-2.53.6-3.967,2.857-3.967,5.572V14.4L4,16.166v.882H18.107v-.882Z" transform="translate(-4 -2.5)"/>
                    </svg>
                    Ver todos</span>
                </a>
              </div>

              <div v-if="!loadings.notice && !notices.length" class="empty-announcements">
                <p class="nunito">Você não possui comunicados até o momento.</p>
                <img v-if="!showFeelingsDay" src="../../../..../../../assets/img/home/empty-announcements.png" class="img-responsive" alt="sem comunicado"/>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-registers-list">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <i v-if="!loadings.points" v-on:click="forcePoint()" v-tooltip.top-center="'A última atualização dos dados foi feita no dia ' + this.datesAtt.points + '. Para atualizar novamente, clique aqui.'" class="fa fa-info-circle info-help" aria-hidden="true"></i>
              <progress-loading v-if="loadings.points" :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; width: 20%;'"/>
              <p v-if="!loadings.points && listPoint.length" class="certa title">Último<span v-if="listPoint.length >= 2">s {{listPoint.length}}</span> dia<span v-if="listPoint.length >= 2">s</span></p>

              <progress-loading v-if="loadings.points" :additionalBoxStyle="'position: absolute;right: 145px;width: 100px; top: 0;'" :additionalLineStyle="'height: 16px; width: 100%;'"/>
              <progress-loading v-if="loadings.points" :additionalBoxStyle="'position: absolute;right: 15px;width: 100px; top: 0;'" :additionalLineStyle="'height: 16px; width: 100%;'"/>
              <div v-if="!loadings.points" class="box-type">
                <svg v-on:click="changeDistribution(1)" v-bind:class="{'active-type': typeDistributionPoint === 1}" width="20" height="20" viewBox="0 0 20 20">
                  <path class="a" d="M4,10H8.167V5H4Zm0,5.833H8.167v-5H4Zm5,0h4.167v-5H9Zm5,0h4.167v-5H14ZM9,10h4.167V5H9Zm5-5v5h4.167V5Z" transform="translate(-0.667 -0.833)"/>
                </svg>
                <svg v-on:click="changeDistribution(2)" v-bind:class="{'active-type': typeDistributionPoint === 2}" width="20" height="20" viewBox="0 0 20 20">
                  <path class="a" d="M5,8.5H7.5v8.167H5ZM9.667,5H12V16.667H9.667Zm4.667,6.667h2.333v5H14.333Z" transform="translate(-0.833 -0.833)"/>
                </svg>
              </div>

              <p v-if="!loadings.points" class="certa"
                 v-bind:class="{
                    'show-all-points': listPoint.length,
                    'show-all-points-empty': !listPoint.length}">
                <a href="/historico-de-ponto">
                  <svg width="20" height="20" viewBox="0 0 20 20">
                    <path class="b" d="M11,3a7.5,7.5,0,0,0-7.5,7.5H1l3.242,3.242.058.117L7.667,10.5h-2.5a5.861,5.861,0,1,1,1.717,4.117L5.7,15.8A7.5,7.5,0,1,0,11,3Zm-.833,4.167v4.167l3.567,2.117.6-1.008-2.917-1.733V7.167Z" transform="translate(-0.167 -0.5)"/>
                  </svg>
                  Ver histórico
                </a>
              </p>
            </div>

            <div v-if="typeDistributionPoint === 1" class="col-xs-12 col-sm-12 col-md-12">
              <div class="row">
                <div v-if="loadings.points" v-for="l1 in 4" class="col-xs-12 col-sm-6 col-md-3">
                  <div class="col-xs-12 col-sm-12 col-md-12 default-box point-content">
                    <a>
                      <div class="day-info">
                        <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; width: 40%;'"/>
                      </div>
                      <div class="register-info">
                        <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; width: 40%;'"/>
                        <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; width: 40%;'"/>
                      </div>
                      <div class="status">
                        <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 24px; display: block; width: 100%;'"/>
                      </div>
                    </a>
                  </div>
                </div>
                <div v-if="!loadings.points" v-for="(point, index) in listPoint" class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <div class="col-xs-12 col-sm-12 col-md-12 default-box point-content point-content-justify">
                    <a v-bind:href="'/detalhe-do-ponto/' + point.id + '/' + 3">
                      <div class="day-info">
                        <p class="certa">{{point.date}}</p>
                        <span v-if="point.hasToJustify && !point.justify" class="justify-he" v-tooltip.top-center="'Existem horas excedentes à justiticar'">Justificar HE</span>
<!--                        <p class="nunito">{{ point.totalPoints}} Registros de ponto</p>-->
                      </div>
                      <div class="register-info">
                        <p v-if="point.recordedPauses" class="recorded-pauses nunito">Pausas:<span>{{point.recordedPauses}}</span></p>
                        <p class="nunito">
                          Registros de ponto:
                          <span>{{point.totalPoints}}</span>
                        </p>

                        <p class="nunito">Total Trabalhado:
                          <span>{{point.workedHours}}</span>
                          <img title="Ajuste pendente" v-if="point.userPointAdjustmentStatus === 1" src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive background-bue" alt="build"/>
                          <img title="Ajuste realizado neste dia" v-if="point.userPointAdjustmentStatus === 2" src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive background-green" alt="build"/>
                          <img title="Ajuste reprovado neste dia" v-if="point.userPointAdjustmentStatus === 3" src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive background-red" alt="build"/>
                        </p>
                      </div>
                      <div class="status">
                        <p v-bind:class="{
                      'background-default': point.userPointDayStatus <= 1,
                      'background-blue': point.userPointDayStatus === 2,
                      'background-green': point.userPointDayStatus === 3,
                      'background-yellow': point.userPointDayStatus === 4,
                      'background-red': point.userPointDayStatus === 5}" class="nunito background-default">{{point.userPointDayStatusStr}}</p>
                      </div>
                    </a>
                  </div>
                </div>
                <div v-if="!loadings.points && !listPoint.length" class="point-empty-list">
                  <img src="../../../..../../../assets/img/empty/historico.png" alt="historico" class="img-fluid img-responsive" />
                  <p class="nunito">Seus últimos pontos marcados irão aparecer aqui.</p>
                </div>
              </div>
            </div>

            <div v-if="typeDistributionPoint === 2" class="col-xs-12 col-sm-12 col-md-12">
              <ul v-if="!loadings.points && listPoint.length" class="point-list custom-scrollbar-wh">
                <li v-for="(point, index) in listPoint">
                  <div class="progress" v-bind:class="{
                    'background-progress': !point.workedHoursPercentage,
                    'background-yellow': point.workedHoursPercentage && point.workedHoursPercentage < 100,
                    'background-green': point.workedHoursPercentage >= 100}">
                    <div v-bind:style="{'height': point.workedHoursPercentageReverse <= 100 ? point.workedHoursPercentageReverse  + 'px' : '0px'}"></div>
                  </div>
                  <div class="infos">
                    <!-- Hours -->
                    <a v-bind:href="'/detalhe-do-ponto/' + point.id + '/' + 5" target="_blank">
                      <p class="certa hours"
                         v-bind:class="{
                      'content-out': point.userPointDayStatus <= 1,
                      'color-green': point.userPointDayStatus === 2,
                      'color-blue': point.userPointDayStatus === 3,
                      'color-orange': point.userPointDayStatus === 4,
                      'color-red': point.userPointDayStatus === 5}"
                      >{{point.workedHours}}</p></a>

                    <!-- Day -->
                    <a v-bind:href="'/detalhe-do-ponto/' + point.id + '/' + 5" target="_blank">
                      <p class="nunito day">
                        <span v-if="point.date">{{point.date}}</span>
                        <span v-else class="d-block">&nbsp;</span>
                      </p>
                    </a>

                    <!-- Solicitation -->
                    <a v-bind:href="'/detalhe-do-ponto/' + point.id + '/' + 5" target="_blank">
                      <p class="nunito">
                        <span v-if="point.userPointAdjustmentStatus === 0" class="d-block">&nbsp;</span>
                        <span v-if="point.userPointAdjustmentStatus === 1" v-bind:class="{'background-bue': point.userPointAdjustmentStatus === 1}" class="nunito requested" title="Solicitado">
                          <img src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive" alt="build"/>
                          Solicitado
                        </span>
                        <span v-if="point.userPointAdjustmentStatus === 2" v-bind:class="{'background-green': point.userPointAdjustmentStatus === 2}" class="nunito requested" title="Aprovado">
                          <img src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive" alt="build"/>
                          Aprovado
                        </span>
                        <span v-if="point.userPointAdjustmentStatus === 3" v-bind:class="{'background-red': point.userPointAdjustmentStatus === 3}" class="nunito requested" title="Reprovado">
                          <img src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive" alt="build"/>
                          Reprovado
                        </span>
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
              <ul v-if="!loadings.points && !listPoint.length" class="point-list custom-scrollbar">
                <li v-for="n in 12">
                  <div class="progress background-progress">
                    <div></div>
                  </div>
                  <div class="infos">
                    <!-- Hours -->
                    <p class="certa hours color-default">00:00</p>
                  </div>
                </li>
              </ul>
              <ul v-if="loadings.points" class="point-list custom-scrollbar">
                <li v-for="l2 in 12">
                  <div class="progress background-progress">
                    <div></div>
                  </div>
                  <div class="infos">
                    <!-- Hours -->
                    <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 0 auto; width: 50%;'"/>
                    <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; margin: 8px auto 0; width: 80%;'"/>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<!-- Script from page -->
<script>
  import leftMenu from "../../components/leftMenu";
  import vueFooter from "../../components/footer";
  import progressLoading from "../../components/progressLoading";
  import viewCommunication from '../../modals/viewCommunication.vue';
  import modalNpsCollaborator from '../../modals/modalNpsCollaborator';
  import moment from 'moment'
  import swal from 'sweetalert';

  import {
    HOME_LAST_POINTS2,
    READ_USER_NOTICE,
    HOME_RESUME2,
    USER_ACCESS,
    SEND_USER_FEELING,
    GET_ME_NOTICES,
    GET_MAIN_HOME,
    HOME_LAST_SOLICITATIONS,
    HOME_CHECK_NOTIFICATIONS,
    HOME_NOTIFICATIONS,
    GET_LIS_CHAT,
    CHECK_HAS_MSG_CHAT,
    POINT_HISTORY, CHECK_NPS_USER
  } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";

  export default {
    name: 'list-point',
    components: {
      leftMenu,
      progressLoading,
      vueFooter,
      viewCommunication,
      modalNpsCollaborator,
    },
    data() {
      return {
        setFirstClickHistoryChat: false,
        setFirstClickHistoryList: false,
        chatListPoints: {
          showList: false,
          showChat: false,
          list: [],
          showNew: false,
          count: 0
        },
        historyListPoints: {
          showList: false,
          list: [],
          showNew: false,
          count: 0
        },
        lastForceNotice: 0,
        lastForceBalance: 0,
        lastForcePoint: 0,
        lastForceSolicitation: 0,
        datesAtt: {
          balance: null,
          solicitation: null,
          notice: null,
          points: null
        },
        loadings: {
          notifications: false,
          solicitations: false,
          main: false,
          notice: false,
          points: false,
          balance: false,
          ocAndAbs: false,
          feeling: false,
          chat: false
        },
        showInfoNew: false,
        isDark: null,
        countTimerCache: 0,
        showFeelingsDay: false,
        typeDistributionPoint: 1,
        showPointCache: false,
        dataLastPoint: {
          date: '',
          showCache: false
        },
        dataInterval: '',
        dateNow: '',
        currentTime: '',
        progressPercent: null,
        userInfo: {},
        actualDay: {},
        dataPg: {},
        showDateLastPoint: null,
        dataPg2: {},
        listPoint: [],
        notices: [],
        noticesPending: 0,
        balances: [],
        failRequestPoints: false,
        loadingSendFeeling: false,
        sendFeelingsSuccess: false,
        dataSendFeeling: {
          mood: '',
          comment: '',
          eDeviceType: 3
        },
        dataWork: {
          dayTotalSeconds: '',
          dayProgressSeconds: '',
          dayProgressMissing: '',
          dayHours: '',
          currentMissing: '00:00:00'
        },
        viewAlert: {},
        myIntervals: {
          updateRefreshPg: null,
          updateProgressAndHoursWorking: null,
          updateTimeNow: null
        },
        dataConfig: {
          canSeeHoursBalance: null
        },
        dataSolicitation: {
          listObject: []
        },
      }
    },
    methods: {
      getNpsStatus() {
        REQUEST_SERVICE.get(CHECK_NPS_USER)
          .then((response) => {
            UTIL_SERVICE.console("RESULT CHECK_NPS_USER:", response.data);
            if (response.data.showNps) {
              $("#modalNpsCollaborator").modal();
            }

          }).catch(reason => {
          UTIL_SERVICE.console("RESULT ERROR:", reason.data);
        });
      },
      orderByDate: function (items) {
        return items.filter(item => {
          if (item['date']) return item;
        });
      },
      // Open list from points history
      openList() {
        this.historyListPoints.count = null
        this.historyListPoints.showList = !this.historyListPoints.showList;
        this.historyListPoints.showNew = false;

        this.chatListPoints.showList = false;

        if (!this.setFirstClickHistoryList) {
          this.loadings.notifications = true;
          REQUEST_SERVICE.get(HOME_NOTIFICATIONS).then((response) => {
            UTIL_SERVICE.console("RESULT HOME_NOTIFICATIONS:", response.data);
            this.setFirstClickHistoryList = true;

            response.data.map((value) => {
              this.historyListPoints.list.push({text: value.text, type: 2, date: value.createdAt})
            });

            this.loadings.notifications = false;
          }).catch(reason => {
            this.loadings.notifications = false;
          });
        }

        if (this.historyListPoints.list.length) {
          let history = UTIL_SERVICE.getStorage('historyListPoints');
          history.showNew = false;

          UTIL_SERVICE.saveStorage('historyListPoints', history);
        }
      },
      // Open list from chat
      openListChat() {
        this.chatListPoints.showList = !this.chatListPoints.showList;
        this.chatListPoints.showNew = false;

        this.historyListPoints.showList = false;

        if (!this.setFirstClickHistoryChat) {
          this.loadings.chat = true;
          REQUEST_SERVICE.get(GET_LIS_CHAT).then((response) => {
            UTIL_SERVICE.console("RESULT GET_LIS_CHAT:", response.data);
            this.setFirstClickHistoryChat = true;

            if (response.data.access) {
              this.chatListPoints.list = response.data.result.list;
            }

            let historyListChatCtrl = UTIL_SERVICE.getStorage('historyListChat');
            historyListChatCtrl.showNew = false;
            UTIL_SERVICE.saveStorage('historyListChat', historyListChatCtrl);

            this.loadings.chat = false;
          }).catch(reason => {
            this.loadings.chat = false;
          });
        }
      },
      // Force request
      forceNotice() {
        let dataNow = new Date().getTime();
        if (dataNow > this.lastForceNotice) {
          this.lastForceNotice = dataNow + 60000;

          this.getOnlyNotices();
        }
      },
      forceBalance() {
        let dataNow = new Date().getTime();
        if (dataNow > this.lastForceBalance) {
          this.lastForceBalance = dataNow + 60000;

          this.getDataInfo();
        }
      },
      forceSolicitation() {
        let dataNow = new Date().getTime();
        if (dataNow > this.lastForceSolicitation) {
          this.lastForceSolicitation = dataNow + 60000;

          this.getOnlySolicitations();
        }
      },
      forcePoint() {
        let dataNow = new Date().getTime();
        if (dataNow > this.lastForcePoint) {
          this.lastForcePoint = dataNow + 60000;

          this.getOnlyPoints();
        }
      },
      // Init Configs
      initStorages() {
        // historyListChat
        if (!UTIL_SERVICE.getStorage('configProgressPoint')) {
          UTIL_SERVICE.saveStorage('configProgressPoint',{
            totalPoint: 0,
            newPointRegister: 0,
            fromDay: null
          });
        } else {
          const progressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
          if (progressPoint.fromDay !== moment(new Date()).format('DD/MM/YYYY')) {
            UTIL_SERVICE.saveStorage('configProgressPoint',{
              totalPoint: 0,
              newPointRegister: 0,
              fromDay: null
            });
          }
        }

        // Data control home page
        let homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
        if (!homeCtrl) {
          UTIL_SERVICE.saveStorage('homeCtrl',{
            dateAttBalance: moment(new Date()).format('DD/MM/YYYY HH:mm'),
            dateAttNotice: moment(new Date()).format('DD/MM/YYYY HH:mm'),
            dateAttPoints: moment(new Date()).format('DD/MM/YYYY HH:mm'),
            controlByDate: moment(new Date()).format('DD/MM/YYYY'),
            controlBy2Hours: new Date(moment().add(2, 'hours').format()).getTime(),
            controlBy4Hours: new Date(moment().add(4, 'hours').format()).getTime(),
            totalOcAndAbs: null,
            balances: null,
            notice: null,
            noticesPending: 0,
            listPoint: null,
            resetPoints: false
          });
          this.datesAtt.balance = moment(new Date()).format('DD/MM/YYYY HH:mm');
          this.datesAtt.notice = moment(new Date()).format('DD/MM/YYYY HH:mm');
          this.datesAtt.points = moment(new Date()).format('DD/MM/YYYY HH:mm');

          // Get data points
          this.getPointHistory();

          // Get data info
          this.getDataInfo();
        } else {
          if (homeCtrl.controlByDate === moment(new Date()).format('DD/MM/YYYY')) {
            this.getOnlyMain();

            let dataNow = new Date().getTime();

            this.dataPg2.totalOccurrences = homeCtrl.totalOcAndAbs;
            if (homeCtrl.notice) {
              this.notices = homeCtrl.notice;

              this.noticesPending = 0;
              if (homeCtrl.notice.length) {
                homeCtrl.notice.map((value) => {
                  if (!value.isRead) {
                    this.noticesPending++;
                  }
                })
              }
            }

            if (homeCtrl.balances)
              this.balances = homeCtrl.balances;

            if (homeCtrl.listPoint)
              this.listPoint = homeCtrl.listPoint;

            this.datesAtt.balance = homeCtrl.dateAttBalance;
            this.datesAtt.notice = homeCtrl.dateAttNotice;
            this.datesAtt.points = homeCtrl.dateAttPoints;

            // Att notices before 2 hours
            if (dataNow > homeCtrl.controlBy2Hours) {
              this.getOnlyNotices();
            }

            // Att notices before 4 hours
            if (dataNow > homeCtrl.controlBy4Hours || homeCtrl.resetPoints) {
              this.getOnlyPoints();
            }
          } else {
            // Get data points
            this.getPointHistory();

            // Get data info
            this.getDataInfo();
          }
        }

        // Show New from dark mode
        if (!UTIL_SERVICE.getStorage('showInfoNew')) {
          this.showInfoNew = true;
        }

        // historyListChat
        if (!UTIL_SERVICE.getStorage('historyListChat')) {
          UTIL_SERVICE.saveStorage('historyListChat',{
            list: [],
            count: null,
            showList: false,
            dateAtt: null,
            showChat: false,
            controlBy10min: null
          });

          this.checkNotificationChat();
        } else {
          const notificationChat = UTIL_SERVICE.getStorage('historyListChat');

          this.chatListPoints.showNew = notificationChat.showNew;
          this.chatListPoints.count = notificationChat.count;
          this.chatListPoints.showChat = notificationChat.showChat;

          let dataNow = new Date().getTime();
          if (dataNow > notificationChat.controlBy10min) {
            this.checkNotificationChat();
          } else if (typeof notificationChat.controlBy10min === "undefined") {
            this.checkNotificationChat();
          }
        }

        // Data control list history points pop up
        if (!UTIL_SERVICE.getStorage('historyListPoints')) {
          UTIL_SERVICE.saveStorage('historyListPoints',{
            list: [],
            count: null,
            showList: false,
            showNew: false,
            dateAtt: null,
            controlBy1Hours: null
          });

          this.getOnlyNotification();
        } else {
          const notifications = UTIL_SERVICE.getStorage('historyListPoints');
          this.historyListPoints.list = notifications.list;
          this.historyListPoints.showNew = notifications.showNew;
          this.historyListPoints.count = notifications.count;

          let dataNow = new Date().getTime();
          if (dataNow > notifications.controlBy1Hours) {
            this.getOnlyNotification();
          } else if (typeof notifications.controlBy1Hours === "undefined") {
            this.getOnlyNotification();
          }
        }

        // Data control list history points
        if (!UTIL_SERVICE.getStorage('pointHistoryCtrl')) {
          UTIL_SERVICE.saveStorage('pointHistoryCtrl',{
            dateAtt: null,
            getRequest: true,
            initDate: null,
            endDate: null,
            listHistory: []
          });
        }

        // Data control list history points
        if (!UTIL_SERVICE.getStorage('userProfile')) {
          UTIL_SERVICE.saveStorage('userProfile', {
            data: null
          });
        }

        // Data my mirrors.
        if (!UTIL_SERVICE.getStorage('mirrorCtrl')) {
          UTIL_SERVICE.saveStorage('mirrorCtrl', {
            dateAtt: null,
            dataControl: null,
            data: null,
            pageNumber: null,
            haveMore: null
          });
        }

        // Data my request
        if (!UTIL_SERVICE.getStorage('myRequestsCtrl')) {
          UTIL_SERVICE.saveStorage('myRequestsCtrl', {
            dateAtt: null,
            dataControl: null,
            data: null
          });
        }

        // Data control hour balance
        if (!UTIL_SERVICE.getStorage('hourBalanceCtrl')) {
          UTIL_SERVICE.saveStorage('hourBalanceCtrl', {
            data: null,
            dateAtt: null,
            dataControl: null
          });
        }

        // Data control occurrence
        if (!UTIL_SERVICE.getStorage('hourBalanceCtrl')) {
          UTIL_SERVICE.saveStorage('myOccurrenceCtrl', {
            data: null,
            dateAtt: null,
            controlBy4Hours: null
          });
        }

        // Data control occurrence
        if (UTIL_SERVICE.getStorage('configMenu')) {
          this.dataConfig = UTIL_SERVICE.getStorage('configMenu');

          if (!UTIL_SERVICE.getStorage('solicitationCtrl')) {
            UTIL_SERVICE.saveStorage('solicitationCtrl', {
              controlBy4Hours: null,
              dateAttSolicitation: null,
              hasOcurrences: null,
              listObject: []
            });

            if (!this.dataConfig.canSeeHoursBalance) {
              this.getOnlySolicitations();
            }
          } else {
            const solicitationCtrl = UTIL_SERVICE.getStorage('solicitationCtrl');
            this.dataSolicitation.listObject = solicitationCtrl.listObject;
            this.datesAtt.solicitation = solicitationCtrl.dateAttSolicitation;

            let dataNow = new Date().getTime();
            if (dataNow > solicitationCtrl.controlBy4Hours) {
              this.getOnlySolicitations();
            } else if (typeof solicitationCtrl.controlBy4Hours === "undefined") {
              this.getOnlySolicitations();
            }
          }
        } else {
          if (!this.dataConfig.canSeeHoursBalance) {
            this.getOnlySolicitations();
          }
        }
      },
      // Configure time from server
      updateTimeNow() {
        this.dateNow.setSeconds(this.dateNow.getSeconds() + 60);
        this.currentTime = moment(this.dateNow, "YYYYMMDD HH:mm").format('HH:mm');
      },
      // Configure progressbar
      updateProgressAndHoursWorking() {
        this.dataWork.dayProgressSeconds += 1;
        this.progressPercent = (this.dataWork.dayProgressSeconds/this.dataWork.dayTotalSeconds * 100)/100 * 100;

        if (this.dataWork.dayProgressMissing) {
          this.dataWork.dayProgressMissing -= 1;

          let hh = Math.floor(this.dataWork.dayProgressMissing / 3600);
          if (hh.toString().length === 1) hh = "0" + hh;
          let mm = Math.floor(this.dataWork.dayProgressMissing % 3600 / 60);
          if (mm.toString().length === 1) mm = "0" + mm;
          let ss = Math.floor(this.dataWork.dayProgressMissing % 60);
          if (ss.toString().length === 1) ss = "0" + ss;

          this.dataWork.currentMissing = hh + ":" + mm + ":" + ss;
        }

        let h = Math.floor(this.dataWork.dayProgressSeconds / 3600);
        if (h.toString().length === 1) h = "0" + h;
        let m = Math.floor(this.dataWork.dayProgressSeconds % 3600 / 60);
        if (m.toString().length === 1) m = "0" + m;
        let s = Math.floor(this.dataWork.dayProgressSeconds % 60);
        if (s.toString().length === 1) s = "0" + s;

        this.dataWork.dayHours = h + ":" + m + ":" + s;
      },
      setProgressBar() {
        if (this.dataPg.workedHours) {
          this.dataWork.dayHours = this.dataPg.workedHours;
        } else {
          this.dataWork.dayHours = "00:00:00";
        }

        if (this.dataPg.hoursMissing && this.dataPg.hoursMissing !== "00:00:00") {
          this.dataWork.currentMissing = this.dataPg.hoursMissing;
          let whSecondsMissing = this.dataPg.hoursMissing;
          let c = whSecondsMissing.split(':');
          if (c.length >= 3) {
            this.dataWork.dayProgressMissing = (+c[0]) * 60 * 60 + (+c[1]) * 60 + (+c[2]); // minutes are worth 60 seconds. Hours are worth 60 minutes.
          } else {
            this.dataWork.dayProgressMissing = (+c[0]) * 60 * 60 + (+c[1]) * 60 + (+0); // minutes are worth 60 seconds. Hours are worth 60 minutes.
          }
        } else {
          this.dataWork.currentMissing = "00:00:00";
        }

        if (this.dataPg.workedHours && this.dataPg.workingDayTotal) {
          let whSeconds = this.dataPg.workedHours; // your input string
          let a = whSeconds.split(':'); // split it at the colons
          if (a.length >= 3) {
            this.dataWork.dayProgressSeconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]); // minutes are worth 60 seconds. Hours are worth 60 minutes.
          } else {
            this.dataWork.dayProgressSeconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+0); // minutes are worth 60 seconds. Hours are worth 60 minutes.
          }

          let wdtSeconds = this.dataPg.workingDayTotal;
          let b = wdtSeconds.split(':');

          if (b.length >= 3) {
            this.dataWork.dayTotalSeconds = (+b[0]) * 60 * 60 + (+b[1]) * 60 + (+b[2]);
          } else {
            this.dataWork.dayTotalSeconds = (+b[0]) * 60 * 60 + (+b[1]) * 60 + (+0);
          }

          this.progressPercent = (this.dataWork.dayProgressSeconds/this.dataWork.dayTotalSeconds * 100)/100 * 100;

          if (this.dataPg.userPointDayStatus === 2) {
            this.myIntervals.updateProgressAndHoursWorking = setInterval(() => this.updateProgressAndHoursWorking(), 1000);
          }
        }
      },
      // Get Initial data page
      getPointHistory() {
        this.loadings.points = true;
        this.loadings.main = true;
        this.failRequestPoints = false;

        let url = HOME_LAST_POINTS2;
        url += "?i=" + this.userInfo.id;

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT HOME_LAST_POINTS2:", response.data);
          let homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          homeCtrl.controlByDate = moment(new Date()).format('DD/MM/YYYY');
          homeCtrl.controlBy4Hours = new Date(moment().add(4, 'hours').format()).getTime();
          homeCtrl.dateAttPoints = moment(new Date()).format('DD/MM/YYYY HH:mm');

          this.dataPg = response.data;
          this.datesAtt.points = homeCtrl.dateAttPoints;

          try {
            const dateLastPoint = UTIL_SERVICE.getStorage('dataDateLastPoint');
            if (dateLastPoint) {
              if (dateLastPoint.date) {
                this.showDateLastPoint = moment(dateLastPoint.date).format('DD/MM/YYYY HH:mm');
              } else {
                this.showDateLastPoint = moment(dateLastPoint).format('DD/MM/YYYY HH:mm');
              }
            } else {
              this.showDateLastPoint = this.dataPg.lastPoint;
            }
          } catch (e) {
            this.showDateLastPoint = this.dataPg.lastPoint;
          }

          if (response.data.points) {
            response.data.points.map((value, index) => {
              value.workedHoursPercentageReverse = (100 - value.workedHoursPercentage);
              this.listPoint.push(value);

              if (response.data.points.length === index + 1) {
                homeCtrl.listPoint = this.listPoint;

                UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
              }
            });
          } else {
            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
          }

          this.dateNow = new Date(this.dataPg.date);
          this.currentTime = moment(this.dateNow, "YYYYMMDD HH:mm").format('HH:mm');
          this.myIntervals.updateTimeNow = setInterval(() => this.updateTimeNow(), 60000);

          setTimeout(()=>{
            this.setProgressBar();
          },200);

          this.loadings.main = false;
          this.loadings.points = false;
        }).catch(reason => {
          this.loadings.main = false;
          this.loadings.points = false;
        });
      },
      getDataInfo() {
        this.loadings.notice = true;
        this.loadings.balance = true;
        this.loadings.ocAndAbs = true;

        // Url Request
        let url = HOME_RESUME2;
        url += "?i=" + this.userInfo.id;

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT HOME_RESUME2:", response.data);
          let homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          homeCtrl.dateTime = moment(new Date()).format('DD/MM/YYYY  HH:mm');
          homeCtrl.controlByDate = moment(new Date()).format('DD/MM/YYYY');
          homeCtrl.controlBy2Hours = new Date(moment().add(2, 'hours').format()).getTime();
          homeCtrl.dateAttBalance = moment(new Date()).format('DD/MM/YYYY HH:mm');
          homeCtrl.dateAttNotice = moment(new Date()).format('DD/MM/YYYY HH:mm');

          this.configInfoPointCache(response.data.totalPoints);

          this.dataPg2 = response.data;
          this.noticesPending = 0;
          this.datesAtt.balance = homeCtrl.dateAttBalance;
          this.datesAtt.notice = homeCtrl.dateAttNotice;

          if (response.data.balances)
            this.balances = response.data.balances;

          if (response.data.notices) {
            this.notices = response.data.notices;

            // Count Notices
            if (this.notices.length) {
              this.notices.map((value, index) => {
                if (!value.isRead) {
                  this.noticesPending ++;
                }

                if (this.notices.length === index + 1) {
                  homeCtrl.notice = this.notices;
                  homeCtrl.noticesPending = this.noticesPending;
                  homeCtrl.balances = response.data.balances;
                  homeCtrl.totalOcAndAbs = response.data.totalOccurrences;

                  UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
                }
              })
            } else {
              homeCtrl.noticesPending = this.noticesPending;
              homeCtrl.notice = response.data.notices;
              homeCtrl.balances = response.data.balances;
              homeCtrl.totalOcAndAbs = response.data.totalOccurrences;

              UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
            }
          } else {
            homeCtrl.noticesPending = this.noticesPending;
            homeCtrl.notice = response.data.notices;
            homeCtrl.balances = response.data.balances;
            homeCtrl.totalOcAndAbs = response.data.totalOccurrences;

            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
          }

          this.loadings.balance = false;
          this.loadings.notice = false;
          this.loadings.ocAndAbs = false;
        }).catch(reason => {
          this.loadings.balance = false;
          this.loadings.ocAndAbs = false;
          this.loadings.notice = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      updateTimer5Min() {
        this.countTimerCache++;

        if (this.countTimerCache >= 5) {
          window.location.reload();
          clearInterval(this.myIntervals.updateTimeNow);
        }
      },
      configInfoPointCache(totalPoints) {
        try {
          const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
          if (dataConfigProgressPoint.newPointRegister) {
            if (dataConfigProgressPoint.newPointRegister > totalPoints) {
              this.showPointCache = true;

              this.myIntervals.updateRefreshPg = setInterval(() => this.updateTimer5Min(), 60000);
            } else {
              UTIL_SERVICE.saveStorage('configProgressPoint',{
                totalPoint: totalPoints,
                newPointRegister: totalPoints,
                fromDay: moment(new Date()).format('DD/MM/YYYY')
              });
            }
          } else {
            UTIL_SERVICE.saveStorage('configProgressPoint',{
              totalPoint: totalPoints,
              newPointRegister: totalPoints,
              fromDay: moment(new Date()).format('DD/MM/YYYY')
            });
          }
        } catch (e) {}
      },
      // Get only main box
      getOnlyMain() {
        this.loadings.main = true;
        let url = GET_MAIN_HOME;
        url += "?i=" + this.userInfo.id;

        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_MAIN_HOME:", response.data);

          this.dataPg = response.data;
          this.dateNow = new Date(this.dataPg.date);
          this.currentTime = moment(this.dateNow, "YYYYMMDD HH:mm").format('HH:mm');
          this.myIntervals.updateTimeNow = setInterval(() => this.updateTimeNow(), 60000);

         this.configInfoPointCache(response.data.totalPoints);

          try {
            const dateLastPoint = UTIL_SERVICE.getStorage('dataDateLastPoint');
            if (dateLastPoint) {
              if (dateLastPoint.date) {
                this.showDateLastPoint = moment(dateLastPoint.date).format('DD/MM/YYYY HH:mm');
              } else {
                this.showDateLastPoint = moment(dateLastPoint).format('DD/MM/YYYY HH:mm');
              }
            } else {
              this.showDateLastPoint = this.dataPg.lastPoint;
            }
          } catch (e) {
            this.showDateLastPoint = this.dataPg.lastPoint;
          }

          setTimeout(() => {
            this.setProgressBar();
          },200);

          this.loadings.main = false;
        }).catch(reason => {
          this.loadings.main = false;
        })
      },
      // Get only notices
      getOnlyNotices() {
        this.loadings.notice = true;
        REQUEST_SERVICE.get(GET_ME_NOTICES).then((response) => {
          UTIL_SERVICE.console("RESULT GET_ME_NOTICES:", response.data);

          let homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          homeCtrl.controlBy2Hours = new Date(moment().add(2, 'hours').format()).getTime();
          homeCtrl.dateAttNotice = moment(new Date()).format('DD/MM/YYYY HH:mm');

          this.noticesPending = 0;
          this.notices = response.data;

          // Check data exist to map
          if (response.data.length) {
            response.data.map((value, index) => {
              if (!value.isRead) {
                this.noticesPending ++;
              }

              if (response.data.length === index + 1) {
                homeCtrl.notice = response.data;
                homeCtrl.noticesPending = this.noticesPending;
                UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
              }
            })
          } else {
            homeCtrl.noticesPending = this.noticesPending;
            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
          }
          this.loadings.notice = false;
        }).catch(reason => {
          this.loadings.notice = false;
        })
      },
      // Get only Points
      getOnlyPoints() {
        this.loadings.points = true;

        let url = HOME_LAST_POINTS2;
        url += "?i=" + this.userInfo.id;

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT getOnlyPoints:", response.data);
          let homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          homeCtrl.controlBy4Hours = new Date(moment().add(4, 'hours').format()).getTime();
          homeCtrl.dateAttPoints = moment(new Date()).format('DD/MM/YYYY HH:mm');
          homeCtrl.resetPoints = false;

          this.datesAtt.points = homeCtrl.dateAttPoints;
          this.listPoint = [];

          if (response.data.points) {
            response.data.points.map((value, index) => {
              value.workedHoursPercentageReverse = (100 - value.workedHoursPercentage);
              this.listPoint.push(value);

              if (response.data.points.length === index + 1) {
                homeCtrl.listPoint = this.listPoint;

                UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
              }
            });
          } else {
            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
          }

          this.loadings.points = false;
        }).catch(reason => {
          this.loadings.points = false;
        });
      },
      // Get only last solicitations
      getOnlySolicitations() {
        this.loadings.solicitations = true;

        let url = HOME_LAST_SOLICITATIONS;
        url += "?i=" + this.userInfo.id;

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT HOME_LAST_SOLICITATIONS:", response.data);

          this.dataSolicitation = response.data;
          this.datesAtt.solicitation = moment(new Date()).format('DD/MM/YYYY HH:mm');

          let solicitationCtrl = UTIL_SERVICE.getStorage('solicitationCtrl');
          solicitationCtrl.controlBy4Hours = new Date(moment().add(4, 'hours').format()).getTime();
          solicitationCtrl.dateAttSolicitation = moment(new Date()).format('DD/MM/YYYY HH:mm');
          solicitationCtrl.hasOcurrences = response.data.hasOcurrences;
          solicitationCtrl.listObject = response.data.listObject;

          UTIL_SERVICE.saveStorage('solicitationCtrl', solicitationCtrl);

          this.loadings.solicitations = false;
        }).catch(reason => {
          this.loadings.solicitations = false;
        });
      },
      // Check has notification chat
      checkNotificationChat() {
        REQUEST_SERVICE.get(CHECK_HAS_MSG_CHAT + this.userInfo.id).then((response) => {
          UTIL_SERVICE.console("RESULT CHECK_HAS_MSG_CHAT:", response.data);
          let historyListChatCtrl = UTIL_SERVICE.getStorage('historyListChat');
          historyListChatCtrl.controlBy10min = new Date(moment().add(10, 'minutes').format()).getTime();
          historyListChatCtrl.dateAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');
          historyListChatCtrl.count = response.data;
          historyListChatCtrl.showNew = !!response.data;

          UTIL_SERVICE.saveStorage('historyListChat', historyListChatCtrl);

          this.chatListPoints.showNew = !!response.data;
          this.chatListPoints.count = response.data;
        }).catch(reason => {});
      },
      // Get only notifications
      getOnlyNotification() {
        let url = HOME_CHECK_NOTIFICATIONS;

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT HOME_CHECK_NOTIFICATIONS:", response.data);
          let historyListPointsCtrl = UTIL_SERVICE.getStorage('historyListPoints');
          historyListPointsCtrl.controlBy1Hours = new Date(moment().add(1, 'hours').format()).getTime();
          historyListPointsCtrl.dateAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');
          historyListPointsCtrl.showNew = response.data.hasNotification;
          historyListPointsCtrl.count = response.data.count;

          UTIL_SERVICE.saveStorage('historyListPoints', historyListPointsCtrl);

          this.historyListPoints.showNew = response.data.hasNotification;
          this.historyListPoints.count = response.data.count;
        }).catch(reason => {});
      },
      // Open notice
      openNotice(item){
        REQUEST_SERVICE.get(READ_USER_NOTICE + item.id).then((response) => {
          UTIL_SERVICE.console("RESULT READ_USER_NOTICE:", response.data);

          item.isRead = true;
          this.viewAlert = response.data;

          let homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          if (homeCtrl.notice !== null) {
            homeCtrl.notice.map((value, index) => {
              if (value.id === item.id) {
                if (!value.isRead) {
                  value.isRead = true;

                  homeCtrl.noticesPending = homeCtrl.noticesPending -1;

                  this.noticesPending--;
                }
              }

              if (homeCtrl.notice.length === index + 1) {
                UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl);
              }
            });
          }

          $("#viewCommunication").modal();
        })
      },
      // Data component feelings
      addFeeling(value) {
        this.dataSendFeeling.mood = value;
      },
      sendFeelings() {
        if (!this.loadingSendFeeling && this.dataSendFeeling.mood >= 0 && this.dataSendFeeling.mood !== '') {
          this.dataSendFeeling.deviceType = 3;
          this.dataSendFeeling.deviceId = JSON.parse(window.localStorage.getItem('browserId'));

          this.loadingSendFeeling = true;

          UTIL_SERVICE.console("DATA SEND:", this.dataSendFeeling);

          REQUEST_SERVICE.post(SEND_USER_FEELING, this.dataSendFeeling).then((response) => {
            UTIL_SERVICE.console("RESULT SEND_USER_FEELING:", response.data);

            window.localStorage.setItem('showFeelings', JSON.stringify({feelings: false}));

            this.loadingSendFeeling = false;
            this.sendFeelingsSuccess = true;
            setTimeout(() => {
              this.showFeelingsDay = false;
              this.sendFeelingsSuccess = false;
            }, 3000);
          }).catch(reason => {
            this.loadingSendFeeling = false;
          });
        }
      },
      // Control home view storage
      hiddenNew() {
        // Hidden tooltip from initial user.
        this.showInfoNew = false;

        UTIL_SERVICE.saveStorage('showInfoNew', {showInfoNew: false});
      },
      changeTheme(value) {
        // Change theme light and dark.
        UTIL_SERVICE.saveStorage('darkMode', {dark: value});

        let chooseTheme = UTIL_SERVICE.getStorage('darkMode');
        if (chooseTheme) {
          this.isDark = chooseTheme.dark;
        } else {
          this.isDark = false;
        }

        UTIL_SERVICE.setTheme();
      },
      realodPage() {
        UTIL_SERVICE.historyLog(false, window.location.pathname, 'realodPage', {realodProcess: true}, false, null);
        window.location.reload();
      },
      changeDistribution(value) {
        // Change distribution from list points.
        this.typeDistributionPoint = value;

        UTIL_SERVICE.saveStorage('typeDistributionPoint', {typeDistributionPoint: value});
      },
      // Verificar
      sendIdentifier() {
        setTimeout(() => {
          try {
            this.loadings.feeling = true;
            let browserInfo = UTIL_SERVICE.checkBrowser();
            let url = USER_ACCESS;
            const { dark } = JSON.parse(window.localStorage.getItem('darkMode'))

            url += "?i=" + this.userInfo.id;
            url += "&deviceModel=" + browserInfo.name;
            url += "&version=" + browserInfo.version;
            url += "&deviceId=" + UTIL_SERVICE.getStorage('browserId');
            if ($('#identifier').attr('class'))
              url += "&pushToken=" + $('#identifier').attr('class');

            if(dark === true) {
              url += "&themeMode=" + "2" 
            } else {
              url += "&themeMode=" + "1"
            }

            UTIL_SERVICE.console("URL Send Fellings:", url);

            REQUEST_SERVICE.get(url).then((response) => {
              UTIL_SERVICE.console("RESULT USER_ACCESS:", response.data);

              let historyListChatCtrl = UTIL_SERVICE.getStorage('historyListChat');
              historyListChatCtrl.showChat = response.data.showChat;
              UTIL_SERVICE.saveStorage('historyListChat', historyListChatCtrl);
              UTIL_SERVICE.saveStorage('logoWebUri', {logoWebUri: response.data.logoWebUri});

              this.chatListPoints.showChat = response.data.showChat;

              if (response.data.showMood) {
                this.showFeelingsDay = true;
                window.localStorage.setItem('showFeelings', JSON.stringify({feelings: true}));
              }
              window.localStorage.setItem("3hours", JSON.stringify({timestamp: new Date(moment().add(3, 'hours').format()).getTime()}));
              window.localStorage.setItem('userAccess', JSON.stringify(response.data));

              this.loadings.feeling = false;
            }).catch(reason => {
              this.loadings.feeling = false;
            });
          } catch (e) {
            this.loadings.feeling = false;
          }
        }, 5000);
      },
    },
    watch: {

    },
    beforeMount() {
      window.localStorage.removeItem('homeCtrl');
      UTIL_SERVICE.historyLog(true);

      this.getNpsStatus();

      // Data user
      this.userInfo = UTIL_SERVICE.getStorage('userInfo');
      this.dataConfig.canSeeHoursBalance = this.userInfo.canSeeHoursBalance;

      // Start configs.
      this.initStorages();

      // Check show feelings
      let dataFeeling = UTIL_SERVICE.getStorage('showFeelings');
      if (dataFeeling) this.showFeelingsDay = dataFeeling.feelings;

      // Check distribution from list points.
      let typePoint = UTIL_SERVICE.getStorage('typeDistributionPoint');
      if (typePoint) this.typeDistributionPoint = typePoint.typeDistributionPoint;
    },
    created() {
      // Remove storage
      window.localStorage.removeItem("dataConfirmPoint");
      this.dataLastPoint = UTIL_SERVICE.getStorage('dateLastPointConfirm');
      try {
        const lastPoint = new moment(new Date(this.dataLastPoint.lastDatePoint)).add(5, 'm').toDate();
        const currentDate = new Date();
        if (currentDate.getTime() > lastPoint.getTime()) {
          try { UTIL_SERVICE.saveStorage('dateLastPointConfirm', {lastDatePoint: this.dataLastPoint.lastDatePoint, showCache: false}); } catch (e) {}
          this.dataLastPoint.showCache = false;
        }
      } catch (e) {
        this.dataLastPoint = {
          date: '',
          showCache: false
        };
      }

      // Check call request 3 in 3hours
      if (window.localStorage.getItem("3hours") === null) {
        this.sendIdentifier();
      } else {
        let object = UTIL_SERVICE.getStorage('3hours');
        let dateString = object.timestamp;
        let now = new Date().getTime();

        if (now > dateString) {
          this.sendIdentifier();
        } else {
          let getValue = UTIL_SERVICE.getStorage('showFeelings');
          if (getValue) {
            this.showFeelingsDay = getValue.feelings;
          }
        }
      }
    },
    destroyed() {
      try {
        clearInterval(this.myIntervals.updateProgressAndHoursWorking);
        clearInterval(this.myIntervals.updateTimeNow);
        clearInterval(this.myIntervals.updateRefreshPg);
      } catch (e) {}
    }
  }
</script>

<style lang="scss">

  .point-content-justify {
    .day-info {
      display: flex;
      justify-content: space-between;
    }

    @media screen and (max-width: 1242px) and (min-width: 1200px) {
      min-height: 225px !important;
    }
  }

  .justify-he {
    background: var(--yellowWithText);
    color: #FFFFFF;
    border-radius: 4px;
    padding: 3px 9px;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
  }

  .balance-hours {
    position: relative;
    display: inline-block !important;
  }

  .balance-left {
    left: -6px;
  }

  .content-process-point {
    background: var(--yellowColor2);
    border: 1px solid var(--yellowColor2);
    border-radius: 12px;
    margin-top: 40px;
    padding: 30px;
    margin-bottom: 16px;

    svg {
      margin: auto;
      background: none;
      display: block;
      shape-rendering: auto;
      width: 100px;
      height: 50px;
    }

    h6 {
      font-weight: 500;
      font-size: 18px;
      text-align: center;
      color: var(--titleBox);
    }

    p {
      font-weight: normal;
      font-size: 12px;
      text-align: center;
      color: var(--textSide);
      font-family: "Montserrat", sans-serif;
    }

    button {
      color: var(--linkColor);
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      border: none;
      background: transparent;
      display: block;
      margin: 0 auto;
    }
  }

  .box-alerts {
    display: block;
    &:hover {
      text-decoration: none;
    }
  }

  .box-announcements {
    position: relative;
    .block-urgent {
      position: absolute;
      background: var(--redColor);
      border-radius: 4px;
      color: #ffffff;
      left: 18px;
      font-size: 12px;
      padding: 2px 8px;
      line-height: 16px;
    }

    .m-left {
      margin-left: 90px !important;
    }
  }

  .box-feelings {
    padding: 10px 20px;
  }

  .box-alert2 {
    padding-top: 20px;
    padding-bottom: 10px;

    .info-help {
      position: absolute;
      right: 14px;
      top: 8px;
      cursor: pointer;
      font-size: 12px;
      color:var(--titleBox);
    }

    .title {
      display: block;
      color: var(--titleBox);
      font-size: 16px;

      @media only screen and (max-device-width: 1024px) {
        font-size: 14px;
      }

      @media only screen and (max-device-width: 420px) {
        font-size: 16px;
      }
    }

    .icon-round {
      display: inline-block;
      background: var(--yellowColor);
      padding: 8px;
      border-radius: 100px;
      color: var(--bodyContrast);
      font-size: 22px;
    }

    .occurrences {
      display: inline-block;
      color: var(--yellowColor);
      font-size: 20px;
      font-weight: 500;
      margin-left: 10px;

      @media only screen and (max-device-width: 1024px) {
        font-size: 14px;
      }

      @media only screen and (max-device-width: 420px) {
        font-size: 16px;
      }
    }

    .resolver {
      color: var(--linkColor);
      float: right;
      cursor: pointer;
      font-size: 16px;
      line-height: 26px;
      position: relative;

      &:hover {
        text-decoration: none;
        border-bottom: 1px solid var(--linkColor);
      }
    }

    @media only screen and (max-device-width: 768px) {
      margin-top: 0;
    }

    @media only screen and (max-device-width: 420px) {
      margin-top: 10%;
    }
  }

  .box-requests-documents {
    .title {
      display: flex !important;
      align-items: center !important;
      gap: 5px !important;
      font-weight: 400 !important;
      font-size: 20px !important;
      color: #000000 !important;

      ion-icon {
        color: var(--yellowColor);
      }
    }

    .text-content {
      font-weight: 400;
      font-size: 13px;
      color: #7F8897;

      b {
        font-weight: 500;
      }
    }

    .body-button {
      width: 100%;
      margin-top: 20px;

      .button-send-documents {
        cursor: pointer;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
        background: #352DA5;
        border-radius: 5px;
        padding: 5px 10px;
        transition: .2s;
        text-decoration: none;

        &:hover {
          background: #6860DC;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/listPoint/ListPointsV2.vue